// extracted by mini-css-extract-plugin
export var title = "Title-module--title--18829";
export var h1 = "Title-module--h1--7d906";
export var h2 = "Title-module--h2--940c1";
export var h3 = "Title-module--h3--2d9fa";
export var h4 = "Title-module--h4--a2c04";
export var h5 = "Title-module--h5--04171";
export var black = "Title-module--black--16e98";
export var white = "Title-module--white--87dc2";